import React, {useMemo} from 'react';
import ReactHtmlParser, {convertNodeToElement} from 'react-html-parser';

const POLISH_CHAR_MAP = {
    'ą': 'a', 'ć': 'c', 'ę': 'e', 'ł': 'l', 'ń': 'n',
    'ó': 'o', 'ś': 's', 'ź': 'z', 'ż': 'z'
};

function slugify(text) {
    return text
        .toLowerCase()
        .split('')
        .map(char => POLISH_CHAR_MAP[char] || char)
        .join('')
        .trim()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/(^-|-$)/g, '');
}

function stripTags(html) {
    return html.replace(/<[^>]*>/g, '').trim();
}

function BlogPostContent({content}) {

    const headings = useMemo(() => {
        if (!content) return [];
        const matches = [...content.matchAll(/<h2[^>]*>([\s\S]*?)<\/h2>/gi)];
        const usedSlugs = new Map();

        return matches.map(match => {
            const text = stripTags(match[1]);
            let slug = slugify(text) || 'sekcja';
            const count = usedSlugs.get(slug) || 0;
            usedSlugs.set(slug, count + 1);
            if (count > 0) slug = `${slug}-${count}`;
            return {text, slug};
        });
    }, [content]);

    const transform = useMemo(() => {
        let h2Index = 0;
        return (node, index) => {
            if (node.type === 'tag' && node.name === 'h2') {
                const heading = headings[h2Index];
                h2Index += 1;
                const attribs = {
                    ...node.attribs,
                    id: heading ? heading.slug : undefined,
                    class: [node.attribs.class, 'blog2-post-h2'].filter(Boolean).join(' ')
                };
                return convertNodeToElement({...node, attribs}, index, transform);
            }
            return undefined;
        };
    }, [headings]);

    if (!content) return null;

    const scrollToHeading = (e, slug) => {
        e.preventDefault();
        const el = document.getElementById(slug);
        if (el) {
            window.scrollTo({behavior: 'smooth', top: el.getBoundingClientRect().top + window.scrollY - 100});
        }
    };

    return (
        <div className="blog2-post-body">
            {headings.length > 0 && (
                <div className="blog2-post-toc">
                    <p className="blog2-post-toc-label">spis treści</p>
                    <ol className="blog2-post-toc-list">
                        {headings.map(heading => (
                            <li key={heading.slug}>
                                <a href={`#${heading.slug}`} onClick={e => scrollToHeading(e, heading.slug)}>
                                    {heading.text}
                                </a>
                            </li>
                        ))}
                    </ol>
                </div>
            )}

            <div className="blog2-post-richtext">
                {ReactHtmlParser(content, {transform})}
            </div>
        </div>
    );
}

export default BlogPostContent;
